import React, { type ComponentProps, type ReactNode } from 'react';
import { UniThemeProvider } from '@planne-software/uni/themes';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR as localeText } from '@mui/x-date-pickers/locales';
import { ptBR } from 'date-fns/locale';

type Props = Partial<ComponentProps<typeof UniThemeProvider>> & { children: ReactNode };

const defaults = {
  adapterLocale: ptBR,
  dateAdapter: AdapterDateFns,
  localeText: localeText.components.MuiLocalizationProvider.defaultProps.localeText,
  scoped: true,
};

const UniTheme: React.FC<Props> = ({ children, ...rest }) => (
  <UniThemeProvider {...defaults} {...rest}>
    {children}
  </UniThemeProvider>
);

export default UniTheme;
